import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import Moment from "moment";
import Actions from "../../../components/Common/Actions";
import FilledButton from "../../../components/Common/Buttons/FilledButton";
import CommonFilterModal from "../../../components/Common/CommonFilterModal";
import DoctorsFilterOptions from "../../../components/Common/CommonFilterOptions";
import NavBarTitles from "../../../components/Common/TabBar";
import ListPageLayout from "../../../components/Layout";
import Deletepopup from "../../../components/Modal/Deletepopup";
import useDebouncedSearch from "../../../components/Utils/hooks/useDebouncedSearch";
import useDeleteHandler from "../../../components/Utils/hooks/useDeleteHandler";
import usePageChange from "../../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../../components/Utils/hooks/usePaginatedData";
import useSortHandler from "../../../components/Utils/hooks/useSortHandler";
import { careernavBarData, JobPostBreadcrumbs, statuses } from "../const";

const JobPost = () => {
  const navigate = useNavigate();
  const addNewJobPost = {
    id: "addnewpost",
    onClick: () => navigate("/careerjobpostform"),
    style: { width: "240px" },
    label: "Add New Job Post",
  };
  // Sorting
  const [sort, setSort] = useState("newest");
  const [sortName, setSortName] = useState("Newest First");
  const handleSortClick = useSortHandler(setSort, setSortName);
  const [loader, setLoader] = useState(true);
  // Search
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebouncedSearch(setSearch, () =>
    setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }))
  );

  // Filter states
  const [selectedValues, setSelectedValues] = useState({
    department: [],
    designation: [],
    typeofjob: [],
    Status: [],
  });
  const [tempSelectedValues, setTempSelectedValues] = useState({
    department: [],
    designation: [],
    typeofjob: [],
    Status: [],
  });

  const [selectedCategory, setSelectedCategory] = useState("Department");
  const [isFilterModalVisible, setIsFilterModalVisible] = useState(false);

  // Delete state
  const [deleteId, setDeleteId] = useState("");
  const [showDelete, setShowDelete] = useState(false);

  // Pagination
  const { records, totalCount, pagination, setPagination, fetchData } =
    usePaginatedData({
      apiUrl: `${process.env.REACT_APP_API_URL}filters/job_sortlist`,
      initialParams: {
        sort,
        searchText: search,
        selectedValues,
      },
    });

  const handlePageChange = usePageChange(pagination, setPagination);
  const handleDelete = useDeleteHandler(
    "career-add-job-post",
    fetchData,
    setShowDelete
  );

  useEffect(() => {
    setLoader(true);
    fetchData();
  }, [pagination.skip, pagination.limit, selectedValues, sort, search]);

  const handleActive = (id, status) => {
    setLoader(true);
    axios
      .post(
        `${process.env.REACT_APP_API_URL}career-add-job-post/update/${id}`,
        {
          active: !status,
        }
      )
      .then((result) => {
        console.log(result, "result...");
      });
    fetchData();
  };
  const columns = [
    {
      title: "S.No",
      dataIndex: "serial",
      key: "serial",
      fixed: "left",
      render: (text, record, index) => Number(pagination.skip) + (index + 1),
    },
    {
      title: "Department / Function Name",
      dataIndex: "department",
      key: "department",
      fixed: "left",
      width: 200,
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      render: (text) => Moment(text).format("DD-MM-YYYY LT"),
      width: 220,
    },
    {
      title: "Last updated on",
      dataIndex: "updatedAt",
      render: (text) => Moment(text).format("DD-MM-YYYY"),
      width: 220,
    },
    {
      title: "Location",
      dataIndex: "job_Location",
      key: "job_Location",
      width: 180,
    },
    {
      title: "Job Type",
      dataIndex: "type_of_job",
      key: "type_of_job",
      width: 180,
    },
    {
      title: "Open Positions",
      dataIndex: "total_Open_Position",
      key: "total_Open_Position",
      width: 200,
    },
    {
      title: "Position / Designation",
      dataIndex: "designation",
      key: "designation",
      width: 200,
    },
    {
      title: "Job Description",
      key: "job_Description",
      width: 800,
      render: (text, record) => (
        <div
          style={{
            maxHeight: 150,
            overflowY: "auto",
            paddingRight: 8,
          }}
          dangerouslySetInnerHTML={{
            __html: record.job_Description,
          }}
        />
      ),
    },
    {
      title: "Organisation Name",
      dataIndex: "organisation_Name",
      key: "organisation_Name",
      width: 200,
    },
    {
      title: "Employment Start Date",
      dataIndex: "employment_Startdate",
      key: "employment_Startdate",
      width: 170,
    },
    {
      title: "Total Working Days",
      dataIndex: "total_working_days",
      key: "total_working_days",
      width: 170,
    },
    {
      title: "Post Expiry Date",
      dataIndex: "jobpost_expiry",
      key: "jobpost_expiry",
      width: 170,
    },
    {
      title: "Actions",
      key: "actions",
      width: 300,
      render: (_, record) => (
        <Actions
          isEdit={true}
          isDelete={true}
          recordActiveStatus={record.active}
          isActive={true}
          onClickActive={() => handleActive(record._id, record.active)}
          onClickDelete={() => {
            setDeleteId(record._id);
            setShowDelete(true);
          }}
          onClickEdit={() => navigate(`/jobpostedit/${record._id}`)}
        />
      ),
    },
  ];

  // Prepare the data source for the table
  const dataSource = records
    ?.filter((el) => el.show === undefined || el.show === true)
    .map((el) => ({
      key: el._id,
      _id: el._id,
      department: el.department,
      job_Location: el.job_Location,
      type_of_job: el.type_of_job,
      total_Open_Position: el.total_Open_Position,
      designation: el.designation,
      job_Description: el.job_Description,
      organisation_Name: el.organisation_Name,
      employment_Startdate: el.employment_Startdate,
      total_working_days: el.total_working_days,
      jobpost_expiry: el.jobpost_expiry,
      active: el.active,
      createdAt: el.createdAt,
      updatedAt: el.updatedAt,
    }));

  const filters = {
    Department: ["Engineering", "Sales", "Content"],
    Designation: ["Web Developer", "Content Market", "Web Designer"],
    typeofjob: ["Full Time", "Part Time", "Freelancer"],
    Status: statuses,
  };

  useEffect(() => {
    records && setTimeout(() => setLoader(false));
  }, [records]);

  return (
    <ListPageLayout
      breadcrumbs={<JobPostBreadcrumbs last=" bd_name" />}
      addButton={<FilledButton props={addNewJobPost} />}
      titles={<NavBarTitles titles={careernavBarData} />}
      filters={
        <DoctorsFilterOptions
          limit={pagination.limit}
          setLimit={(val) =>
            setPagination((prev) => ({
              ...prev,
              limit: val,
              skip: 0,
              currentPage: 1,
            }))
          }
          search={search}
          onChange={debouncedSearch}
          handleSortClick={handleSortClick}
          sortName={sortName}
          filter_records={() => {}}
          setFilterShow={() => setIsFilterModalVisible(true)}
        />
      }
      tableProps={{
        columns,
        dataSource,
      }}
      totalCount={totalCount}
      pagination={pagination}
      onPageChange={(selected) => handlePageChange({ selected })}
      loader={loader}
    >
      {/* Optional children like modals */}
      {showDelete && (
        <Deletepopup
          handleDelete={() => handleDelete(deleteId)}
          id={deleteId}
          handleClose={() => setShowDelete(false)}
        />
      )}

      <CommonFilterModal
        visible={isFilterModalVisible}
        onClose={() => setIsFilterModalVisible(false)}
        onApply={() => {
          setSelectedValues(tempSelectedValues);
          setIsFilterModalVisible(false);
          setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
        }}
        onReset={() => {
          setLoader(true);
          setTempSelectedValues({
            department: [],
            designation: [],
            typeofjob: [],
            Status: [],
          });
          setSelectedValues({
            department: [],
            designation: [],
            typeofjob: [],
            Status: [],
          });
          setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
          fetchData();
        }}
        filters={filters}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        selectedValues={tempSelectedValues}
        setSelectedValues={setTempSelectedValues}
      />
    </ListPageLayout>
  );
};

export default JobPost;
